import {Search} from "lucide-react";

export interface SearchBarProps {
    searchValue?: string;
    onSearchChange?: (value: string) => void;
    searchPlaceholder?: string;
}

export function SearchBar({
    searchValue,
    onSearchChange,
    searchPlaceholder = 'Search'
}: SearchBarProps){

    return(
        <>
            { onSearchChange &&
                (<div style={{position: 'relative'}}>
                    <Search style={{
                        position: 'absolute',
                        left: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: '14px',
                        height: '14px',
                        color: 'hsl(220 9% 46%)'
                    }}/>
                    <input
                        type="text"
                        value={searchValue}
                        onChange={(e) => onSearchChange?.(e.target.value)}
                        placeholder={searchPlaceholder}
                        style={{
                            width: '100%',
                            height: '28px',
                            padding: '0 0px 0 28px',
                            borderRadius: '6px',
                            border: '1px solid hsl(220 13% 91%)',
                            fontSize: '13px',
                            outline: 'none',
                        }}
                    />
                </div>)}
        </>
    )
}